// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoRecorder/style.css
// module id = 3607
// module chunks = 33